/** Relative tolerance used for contract invariants (ADR 0006). */
export const RELATIVE_TOLERANCE = 1e-9;
export const approxEqual = (a, b, relative = RELATIVE_TOLERANCE) => Math.abs(a - b) <= relative * Math.max(1, Math.abs(a), Math.abs(b));
/** `a ≤ b` up to the contract tolerance. */
export const approxAtMost = (a, b, relative = RELATIVE_TOLERANCE) => a <= b || approxEqual(a, b, relative);
export const sum = (values) => {
    let total = 0;
    for (const value of values)
        total += value;
    return total;
};
//# sourceMappingURL=numeric.js.map